export const dev = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: 'xeqUysFyYq2fsYMSNJj3N7b7o4UxloHH',
        audience: 'https://crew-time/api',
    }
}

export const prod = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: 'xeqUysFyYq2fsYMSNJj3N7b7o4UxloHH',
        audience: 'https://crew-time/api',
    }
}